var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderCancelled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17765_12656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.71415 2.85718C1.41104 2.85718 1.12035 2.97759 0.906024 3.19191C0.691697 3.40624 0.571289 3.69693 0.571289 4.00003V14.2857C0.571289 14.5889 0.691697 14.8795 0.906024 15.0939C1.12035 15.3082 1.41104 15.4286 1.71415 15.4286H14.2856C14.5887 15.4286 14.8794 15.3082 15.0937 15.0939C15.308 14.8795 15.4284 14.5889 15.4284 14.2857V4.00003C15.4284 3.69693 15.308 3.40624 15.0937 3.19191C14.8794 2.97759 14.5887 2.85718 14.2856 2.85718H11.9999",
    stroke: "#FF505A",
    strokeOpacity: 0.87,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0.571533V5.14296",
    stroke: "#FF505A",
    strokeOpacity: 0.87,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.571533V5.14296",
    stroke: "#FF505A",
    strokeOpacity: 0.87,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 2.85718H9.71429",
    stroke: "#FF505A",
    strokeOpacity: 0.87,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0228 11.1658L5.97705 7.12012",
    stroke: "#FF505A",
    strokeOpacity: 0.87,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0228 7.12012L5.97705 11.1658",
    stroke: "#FF505A",
    strokeOpacity: 0.87,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17765_12656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCancelled);
export default __webpack_public_path__ + "static/media/orderCancelled.40bd151652289a08bb9fa1bbf93c8bba.svg";
export { ForwardRef as ReactComponent };